import { render } from "./Benefits.vue?vue&type=template&id=e86f80c6&scoped=true"
import script from "./Benefits.vue?vue&type=script&lang=js"
export * from "./Benefits.vue?vue&type=script&lang=js"

import "./Benefits.vue?vue&type=style&index=0&id=e86f80c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e86f80c6"]])

export default __exports__